/*
    플랫폼
*/
export const PLATFORM = {
  PURPLE: {
    LAUNCHER: 'purpleLauncher',
    INAPP: 'purpleInApp',
    WEBVIEW: 'purpleWebview',
    APP: 'purpleApp', // 퍼플 모바일앱 인앱브라우저 + 웹뷰
  },
  COMMUNITY_SDK: 'communitySDK',
  APP: 'app',
  MOBILE_WEB: 'mobileWeb',
  PC_WEB: 'pcWeb',
  INGAME: 'ingame',
};

/*
    디바이스
*/
export const DEVICE_TYPE = {
  PC: 'pc',
  MOBILE: 'mobile',
};
export const DEVICE = {
  [DEVICE_TYPE.PC]: {
    key: DEVICE_TYPE.PC,
    platform: [PLATFORM.PC_WEB, PLATFORM.PURPLE.LAUNCHER],
  },
  [DEVICE_TYPE.MOBILE]: {
    key: DEVICE_TYPE.MOBILE,
    platform: [PLATFORM.MOBILE_WEB, PLATFORM.APP, PLATFORM.PURPLE.APP, PLATFORM.PURPLE.INAPP, PLATFORM.PURPLE.WEBVIEW],
  },
};
export const BREAKPOINT = {
  [DEVICE_TYPE.PC]: 960,
};

/*
    플랫폼별 UserAgent
    - 소문자로 입력하기 (toLowerCase)
*/
export const USER_AGENT = {
  [PLATFORM.PURPLE.LAUNCHER]: ['ngpclient'],
  [PLATFORM.PURPLE.INAPP]: ['ncmtalk', 'nctmtalk', 'ncjmtalk'],
  [PLATFORM.PURPLE.WEBVIEW]: ['ncmtalk', 'nctmtalk', 'ncjmtalk'],
  [PLATFORM.COMMUNITY_SDK]: ['community'],
  [PLATFORM.APP]: ['ncmop', 'nc noob', 'webview_aos', 'webview_ios', 'unrealengine', 'ncmtalk', 'playstation'],
  [PLATFORM.MOBILE_WEB]: ['android', 'webos', 'iphone', 'ipad', 'ipod', 'blackberry', 'iemobile', 'opera mini'],
  [PLATFORM.INGAME]: ['aioningamebrowser', 'nc ingame', 'lineage2', 'bnsingamebrowser'], // l2 userAgent 재확인 필요
};
